import React from 'react'
import styles from './DeleteModal.module.css'
import classNames from 'classnames'
import { useClearBodyNoScrollClass } from '../../hooks/use-clear-body-no-scroll-slass'

interface DeleteInvoiceModalProps {
  onConfirm: (action: 'return' | 'delete') => void
  onCancel: () => void
}

const DeleteInvoiceModal = ({
  onConfirm,
  onCancel,
}: DeleteInvoiceModalProps) => {
  useClearBodyNoScrollClass()
  return (
    <div style={{ display: 'block' }} className={styles.win}>
      <div className={styles.winContainer}>
        <div className={styles.winContent}>
          <div className={styles.close} onClick={() => onCancel()}>
            ×
          </div>
          <div className={styles.winContentFulltext}>
            <h4
              style={{ textAlign: 'center' }}
              className={classNames(styles.colorRed, styles.h4, 'mb-4')}
            >
              Действительно удалить данный счёт?
            </h4>
            <p style={{ textAlign: 'center' }} className="mb-4">
              Что делать с грузами?
            </p>
            <div className="row mt-2">
              <div
                className="col-6 col-sm mt-1 mb-1"
                style={{ textAlign: 'center' }}
              >
                <button
                  onClick={() => onConfirm('return')}
                  className={classNames(
                    styles.btn,
                    styles.btnSmall,
                    styles.btnBlue,
                    styles.btnNoUppercase,
                    styles.btnFixedSize,
                    'd-block d-sm-inline-block'
                  )}
                >
                  Вернуть к оплате
                </button>
              </div>
              <div
                className="col-6 col-sm mt-1 mb-1"
                style={{ textAlign: 'center', margin: '0' }}
              >
                <button
                  onClick={() => onConfirm('delete')}
                  className={classNames(
                    styles.btn,
                    styles.btnSmall,
                    styles.btnNoUppercase,
                    styles.btnFixedSize,
                    'd-block d-sm-inline-block'
                  )}
                >
                  Удалить с грузами
                </button>
              </div>
              <div
                className="col-12 col-sm-auto mt-1 mb-1"
                style={{ textAlign: 'right' }}
              >
                <div
                  onClick={() => onCancel()}
                  className={classNames(
                    styles.btn,
                    styles.btnSmall,
                    styles.btnBlueOutline,
                    styles.btnNoUppercase,
                    styles.btnFixedSize,
                    'd-block d-sm-inline-block'
                  )}
                >
                  Отмена
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteInvoiceModal
